<template>
  <div class="compaire-movie-box">
    <div class="title as-flex main-between cross-center">
      <div class="left-title f-3">对比影片</div>
      <div class="right-add-btn f-2" @click="addCompaireMovies">添加</div>
    </div>
    <div class="main as-flex main-start cross-center">
      <moviesSoftScroll :movieListBriefInfo="movieListBriefInfo"></moviesSoftScroll>
    </div>
    <el-dialog
      custom-class="addmovie-customize-dialog"
      :visible.sync="showAddCompaireMoviesModal"
      width="70%"
      top="0px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :lock-scroll="true"
      :before-close="handleClose"
    >
      <template v-if="showAddCompaireMoviesModal">
        <addMovieModal @close="closeModal"></addMovieModal>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moviesSoftScroll from "./moviesSoftScroll";
import addMovieModal from "./addCompaireMoviesModal";
export default {
  name: "compaireMoviesBox",
  props: { movieListBriefInfo: {} },
  components: {
    moviesSoftScroll: moviesSoftScroll,
    addMovieModal: addMovieModal
  },
  data() {
    return {
      showAddCompaireMoviesModal: false
    };
  },
  methods: {
    addCompaireMovies() {
      this.showAddCompaireMoviesModal = true;
    },
    handleClose() {
      this.showAddCompaireMoviesModal = false;
    },
    closeModal() {
      this.showAddCompaireMoviesModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.compaire-movie-box {
  width: 100%;
  min-width: 300px;
  height: 100%;
  padding: 10px 10px;
  background-color: #fff;
}
.title {
  height: 40px;
  width: 100%;
  border-bottom: 1px solid #efefef;
  padding: 10px 0px;
  .right-add-btn {
    height: 30px;
    color: #fff;
    padding: 5px 20px;
    background-color: #3085e5;
    box-shadow: 0 0 2px 2px #3085e5;
    border-radius: 15px;
  }
}
.main {
  height: calc(100% - 40px);
  width: 100%;
}
</style>
